import {Injectable} from '@angular/core';
import {ActiveToast, ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {take} from 'rxjs/operators';

@Injectable()
export class AlertService {
    constructor(
        private _toastr: ToastrService,
        private _translateService: TranslateService
    ) {}

    async showSuccess(messageKey: string, titleKey?: string, params?: any, alertConfig?: any): Promise<boolean> {
        return this._computeTranslations(
            (translations) => {
                return this._toastr.success(translations[0], translations[1]);
            },
            messageKey,
            titleKey,
            params
        );
    }

    async showInfo(messageKey: string, titleKey?: string, params?: any, alertConfig?: any): Promise<boolean> {
        return this._computeTranslations(
            (translations) => {
                return this._toastr.info(translations[0], translations[1], params);
            },
            messageKey,
            titleKey,
            params
        );
    }

    async showWarning(messageKey: string, titleKey?: string, params?: any, alertConfig?: any): Promise<boolean> {
        return this._computeTranslations(
            (translations) => {
                return this._toastr.warning(translations[0], translations[1], params);
            },
            messageKey,
            titleKey,
            params
        );
    }

    async showError(messageKey: string, titleKey?: string, params?: any, alertConfig?: any): Promise<boolean> {
        return this._computeTranslations(
            (translations) => {
                return this._toastr.error(translations[0], translations[1], params);
            },
            messageKey,
            titleKey,
            params
        );
    }

    private _computeTranslations(toastFn: (t) => ActiveToast<any>, messageKey: string, titleKey?: string, params?: any): Promise<boolean> {
        return Promise.all([
            messageKey ? this._translateService.get(messageKey, params).toPromise() : undefined,
            titleKey ? this._translateService.get(titleKey, params).toPromise() : undefined
        ])
            .then((translations) => {
                const toast = toastFn(translations);
                if (params?.actionCallback) {
                    toast.onAction.subscribe(params.actionCallback);
                }
                return true;
            })
            .catch((err) => {
                console.log(`[AlertService]: There was an error: ${err}`);
                return false;
            });
    }
}
